<template>
  <div class="relative w-full h-[62.4vw] py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          项目扶持
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          六大运营扶持，盈利更有保障
        </div>
      </div>
    </div>

    <!-- 内容框 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto grid grid-cols-3 gap-[1.46vw]"
    >
      <div
        v-for="(item, index) in contentItems"
        :key="index"
        class="group w-[19.27vw] h-[19.95vw] pb-[0.42vw] bg-white rounded-xl inline-flex flex-col justify-start items-center gap-[2.14vw] overflow-hidden relative transition-all duration-300 hover:shadow-[0_0.6vw_1.5vw_rgba(0,0,0,0.15)]"
      >
        <el-image
          :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/home/module5/image${index + 1}.png`"
          class="w-full h-[11.46vw] rounded-tl-xl rounded-tr-xl object-cover transition-transform duration-300 group-hover:scale-110"
          lazy
          alt="图片"
        />
        <div
          class="relative w-full flex flex-col justify-start items-center gap-[0.21vw] cursor-default"
        >
          <div
            class="relative w-full flex justify-center items-start text-center text-[#1A2233] text-[1.15vw] font-bold font-harmony transition-colors duration-300 group-hover:text-[#05358c]"
          >
            {{ item.title }}
          </div>
          <div
            class="relative w-full flex justify-center items-start text-center text-[#9CA3AF] text-[0.83vw] font-normal font-harmony whitespace-pre-line"
          >
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>

    <!-- 按钮容器 -->
<!--    <el-button-->
<!--      native-type="submit"-->
<!--      class="flex mx-auto mt-[2.2vw] justify-center items-center custom-button"-->
<!--      @mouseenter="hoverButton = true"-->
<!--      @mouseleave="hoverButton = false"-->
<!--      @click="smoothScrollToBottom"-->
<!--    >-->
<!--      申请加盟-->
<!--    </el-button>-->
  </div>
</template>

<script>
export default {
  name: "joinus-module4",
  data() {
    return {
      backgroundImage: require("@/assets/images/Home/module5/sample1.png"),
      contentItems: [
        {
          title: "课程体系全",
          description: "教材、教具、实验室设计方案\n及师资培训全链路课程体系",
        },
        {
          title: "白名单赛事",
          description: "全方位提供专业、权威的无人机\n赛事指导与支持",
        },
        {
          title: "全方位培训",
          description: "为合作伙伴提供全方位的培训\n精心规划师训流程",
        },
        {
          title: "投资轻量化",
          description: "低门槛加盟费，灵活合作模式\n（县区级/市级/省级）",
        },
        {
          title: "落地高效化",
          description: "30天建设，7天师资\n培训结业",
        },
        {
          title: "运营标准化",
          description: "AI管理系统 + 总部全程督导 +\n后期营销赋能",
        },
      ],
    };
  },
  methods: {
    // 平滑滚动到底部
    smoothScrollToBottom() {
      const targetScroll = document.documentElement.scrollHeight;
      const startPosition = window.scrollY || window.pageYOffset;
      const distance = targetScroll - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
        window.scrollTo(0, run);
        if (timeElapsed < 1000) requestAnimationFrame(animation);
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>
